module.exports = __webpack_public_path__ + "static/media/logo-color1.fad03aaa.png";